<template>
  <div>
    <div class="bio_shop">
      <div class="bio_shop_left">
        <div class="bio_shop_left_logo">
          <img
            style="width:100%;height:100%"
            src="https://admin.bioflin.com/img/indexlogo.ccae9644.png"
            alt
          />
        </div>
        <div class="bio_shop_left_nav">
          <div @click="select1(0)" :class="navclass == 0 ? 'bg' : ''">
            <router-link to="/index" tag="div">首页</router-link>
          </div>
          <div @click="select1(1)" :class="navclass == 1 ? 'bg' : ''">
            <router-link to="/shop/goodslist" tag="div">商品</router-link>
          </div>
          <div @click="select1(2)" :class="navclass ==2 ? 'bg' : ''">
            <router-link to="/orderList" tag="div">订单</router-link>
          </div>
          <div @click="select1(3)" :class="navclass ==3 ? 'bg' : ''">
            <router-link to="/sitemain" tag="div">设置</router-link>
          </div>
        </div>
      </div>
      <div class="bio_shop_right">
        <i class="iconfont icon-touxiang" style="font-size:30px"><span>{{username}}</span></i>

        <i class="iconfont icon-vertical_line" style="font-size:30px"></i>

        <router-link to="/index" tag="div" style="margin-right:25px;"><i class="iconfont icon-home" style="font-size:30px"></i></router-link>

        <!-- <i class="iconfont icon-vertical_line" style="font-size:30px"></i>

        <i class="iconfont icon-changyongicon-" style="font-size:30px"></i>

        <i class="iconfont icon-vertical_line" style="font-size:30px"></i>

        <el-badge :value="12" class="item">
          <i
            class="iconfont icon-xiaoxitongzhitixinglingshenglingdang-xianxing"
            style="font-size:30px"
          ></i>
        </el-badge> -->

        <i class="iconfont icon-vertical_line" style="font-size:30px"></i>

        <el-popover placement="top-start" width="50" trigger="hover">
          <span slot="reference" class="item2" style="cursor: pointer;">
            <i class="iconfont icon-guanbi" @click="dialogVisible = true" style="font-size:30px"></i>
          </span>
          <div @click="dialogVisible = true" style="text-align:center;cursor:pointer">退出登录</div>
        </el-popover>
      </div>
    </div>
    <div class="bio_shop2">
      <div class="bioshop_tit">{{name}}</div>
      <div class="bioshop2_rig">
        <div class="bioshop2_rig_cont">
          <div class="bio_icon"></div>
          <div class="bioshop2_title">{{name}}</div>
        </div>
      </div>
    </div>
    <el-dialog title="退出确定" :visible.sync="dialogVisible" width="25%">
      <span>确定要退出登录吗?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="return_login()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible:false,
      navclass: null,
      username: this.$cookies.get('shop_username'),
      navleft: [
        [
          {
            title: "系统首页",
            path: "/index"
          },
          {
            title: "修改密码",
            path: "/changePass"
          },
          // {
          //   title: "商铺美化",
          //   path: "/shopUi"
          // },
          // {
          //   title: "信息设置",
          //   path: "/editUserInfo"
          // }
        ],
        [
          {
            title: "商品列表",
            path: "/shop/goodslist"
          },
          {
            title: "添加商品",
            path: "/shop/addgoods"
          },
          //  {
          //   title: "商品分类",
          //   path: "/shop/setClass"
          // }
        ],
        [
          {
            title: "订单列表",
            path: "/orderList"
          },
          {
            title: "退款申请",
            path: "/orderReturn"
          },
          {
            title: "退货申请",
            path: "/orderReturn2"
          }
        ],
        [
          {
            title: "店铺信息",
            path: "/sitemain"
          },
          {
            title: "增值服务",
            path: "/service"
          },
          // {
          //   title: "账期设置",
          //   path: "/paymentday"
          // }
        ],
      ]
    };
  },
  props: {
    name: String
  },
  watch: {
    // $route(v) {
    //   window.console.log(v);
    // },
    "$store.state.shop_top": {
      handler: function(newrr) {
        this.$store.commit("change_nav", this.navleft[newrr]);
        this.navclass = newrr;
      },
      deep: true
    }
  },

  mounted() {},
  methods: {
    return_login() {
      this.axios
        .get(this.$store.state.serve + "shop/outLogin", {
          params: {
            token: this.$cookies.get("shop_token")
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$alerts.success("退出成功", this.$message);
            this.$router.push("/");
            window.location.reload()
          }
        });
    },
    select1(v) {
      // this.navclass = v;
      this.$store.commit("change_nav", this.navleft[v]);
    }
  }
};
</script>
<style lang="scss">
.bio_shop {
  width: 100%;
  height: 45px;
  background: #3498db;
  display: flex;
  justify-content: space-between;
  .bio_shop_left {
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    .bio_shop_left_logo {
      margin-left: 12px;
      width: 42px;
      height: 90%;
    }
    .bio_shop_left_nav {
      margin-left: 62px;
      display: flex;
      > div {
        text-align: center;
        line-height: 45px;
        width: 60px;
        font-size: 16px;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        height: 45px;
        cursor: pointer;
      }
      > div:hover {
        background: #5fbfff;
      }
      .bg {
        background: #5fbfff;
      }
    }
  }
  .bio_shop_right {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
    color: #fff;
    > i {
      margin-right: 25px;
      cursor: pointer;
    }
  }
}
.bio_shop2 {
  height: 50px;
  background: rgba(238, 238, 238, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  display: flex;
  .bioshop_tit {
    width: 180px;
    border-right: 1px solid #dddddd;
    font-size: 16px;
    font-family: "Microsoft YaHei";
    font-weight: 300;
    color: rgba(153, 153, 153, 1);
    line-height: 50px;
    text-align: center;
  }
  .bioshop2_rig {
    width: 1060px;
    margin: 0 auto;
    height: 100%;
    .bioshop2_rig_cont {
      display: flex;
      align-items: center;
      height: 100%;
      .bioshop2_title {
        font-size: 14px;
        font-family: "Microsoft YaHei";
        font-weight: 300;
        color: rgba(153, 153, 153, 1);
      }
    }
    .bio_icon {
      margin-right: 10px;
      width: 4px;
      height: 16px;
      background: rgba(52, 152, 219, 1);
    }
  }
}
.icon-touxiang{
    span{
      font-size: 14px;
      display: block;
      float: right;
      padding-top: 5px;
    }
}
</style>